import angular from 'angular'

angular.module('nominas.cargacontpaq')
  .config(nominasCargacontpaqConfig);

function nominasCargacontpaqConfig($stateProvider) {
  $stateProvider.state('nominas.cargacontpaq', {
    template: '<nominas-cargacontpaq id-proyecto="idProyecto" id-nomina="idNomina"></nominas-cargacontpaq>',
    url: '/cargacontpaq',
    data: {title: 'Carga CONTPAQi'},
    controller: nominasCargacontpaqConfigComponent,
  });
}

function nominasCargacontpaqConfigComponent($scope) {
  $scope.idProyecto = '1280';
  $scope.idNomina = '1280QNA17090001';
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/routes/cargacontpaq.js